import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <p>Desenvolvido por <a href="http://brunocarvalho.me" target="_blank"><strong>Bruno Carvalho</strong></a></p>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.jsx